export default {
  title: "Wallet Push-билдирмелери",
  pushsBeAbleAfterEntityModeration:
    "Push-билдирмелерди жөнөтүү мүмкүнчүлүгү юридикалык жак модерациядан өткөндөн кийин жеткиликтүү болот",
  toCreatePushBuyTariff:
    "Push-билдирмелерди жөнөтүү үчүн «Промо» же «Про+» тарифи талап кылынат",
  noPushsYet: "Push-билдирмелер азырынча жок",
  newPush: "Жаңы билдирүү",

  aboutChapter: {
    title: "Бөлүм жөнүндө",
    descriptions: [
      "«Wallet Push-билдирмелери» бөлүмүндө сиз кардарларыңызга жаңылыктар, акциялар жана иш-чаралар тууралуу билдирмелерди жөнөтө аласыз.",
      "Жөнөтүлгөн push-билдирмелер таблица түрүндө көрсөтүлөт. Тийиштүү сапты басуу менен кайсы соода түйүнүнө, качан жана кандай билдирме жөнөтүлгөнүн көрө аласыз.",
    ],
    howCreatePush: {
      header: "Кардарларга push-билдирме жөнөтүү тартиби",
      list: [
        "«Жаңы билдирүү» баскычын басыңыз.",
        "Билдирме жөнөтүлө турган соода түйүнүн тандаңыз.",
        "Темасын жазыңыз, мисалы: «Майрамдык арзандатуу».",
        "Билдирменин текстин киргизиңиз.",
        "Маалыматты текшериңиз – жөнөтүлгөндөн кийин өзгөртүү мүмкүн эмес!",
        "«Билдирүү жөнөтүү» баскычын басыңыз.",
      ],
      p1: "Кардарлар билдирмени түзүлгөндөн кийин 15 мүнөттүн ичинде алышат. Жөнөтүлгөн билдирмени өзгөртүү же жокко чыгаруу мүмкүн эмес.",
      p2: "<span>Маанилүү!</span> Push-билдирмелерди Wallet картасын телефондоруна кошкон кардарлар гана алышат.",
    },
    hotGetWalletCard: {
      header: "Кардар Wallet картасын кантип чыгарат",
      list: [
        "RC PAY мобилдик тиркемесине кирүү.",
        "Сиздин мекемеңиздин Wallet картасын чыгаруу.",
        "Аны Apple Wallet (iOS) же Google Pay (Android) колдонмолоруна кошуу.",
      ],
    },
  },

  creatingPushNotAvailable: "Билдирме жөнөтүү мүмкүн эмес",
  clientsGetPushWithin: "Кардарлар push-билдирмени 15 мүнөт ичинде алышат.",
  pushCreatedAndInProgress: "Билдирме түзүлдү жана иштетилүүдө",

  pushCreating: "Билдирме түзүү",
  pushHeader: "Билдирменин темасы",
  carefullyReadText: "Текстти кунт коюп окуңуз",
  afterCreateUCantChangeIt:
    "Билдирме түзүлгөндөн кийин аны өзгөртүү мүмкүн эмес.",
  messageText: "Билдирме тексти",
  createPush: "Билдирме жөнөтүү",
  pushInfo: "Билдирме жөнүндө маалымат",
};
